const VideoSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 border border-[#2D5016] rounded-full mb-6">
            <span className="text-[#2D5016] text-sm font-medium">I Nostri Video</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-serif text-[#2D5016] mb-4">
            Scopri il Nostro Mondo
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Immergiti nelle storie che raccontano la passione e la dedizione dietro ogni nostro prodotto
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          <div className="relative h-96 rounded-3xl overflow-hidden shadow-2xl group">
            <img
              src="https://public.readdy.ai/ai/img_res/02c37fca462beece97fcf00c24d0f6c1.jpg"
              alt="Video 1"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors"></div>
            <button className="absolute inset-0 flex items-center justify-center cursor-pointer" aria-label="Play video">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-2xl">
                <i className="ri-play-fill text-[#2D5016] text-3xl ml-1"></i>
              </div>
            </button>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-white text-2xl font-serif mb-2">Il Viaggio delle Spezie</h3>
              <p className="text-white/90 text-sm">Dal campo alla tua cucina</p>
            </div>
          </div>

          <div className="relative h-96 rounded-3xl overflow-hidden shadow-2xl group">
            <img
              src="https://readdy.ai/api/search-image?query=artisan%20baker%20preparing%20organic%20cookies%20in%20rustic%20kitchen%20with%20warm%20lighting%2C%20close%20up%20hands%20kneading%20dough%20with%20flour%20dust%20in%20air%2C%20documentary%20style%20food%20photography%20with%20authentic%20craftsmanship%20and%20natural%20warm%20tones&width=800&height=600&seq=video2&orientation=landscape"
              alt="Video 2"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors"></div>
            <button className="absolute inset-0 flex items-center justify-center cursor-pointer" aria-label="Play video">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-2xl">
                <i className="ri-play-fill text-[#2D5016] text-3xl ml-1"></i>
              </div>
            </button>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-white text-2xl font-serif mb-2">L'Arte dei Biscotti</h3>
              <p className="text-white/90 text-sm">Tradizione e innovazione</p>
            </div>
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden shadow-2xl">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20cinematic%20shot%20of%20organic%20farm%20at%20golden%20hour%20with%20farmers%20working%20in%20spice%20fields%2C%20aerial%20perspective%20showing%20vast%20agricultural%20landscape%20with%20natural%20green%20colors%2C%20documentary%20style%20photography%20with%20warm%20sunset%20lighting%20and%20authentic%20farming%20scene&width=1600&height=600&seq=video3&orientation=landscape"
            alt="Video principale"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
          <button className="absolute inset-0 flex items-center justify-center cursor-pointer" aria-label="Play video">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center hover:scale-110 transition-transform shadow-2xl">
              <i className="ri-play-fill text-[#2D5016] text-4xl ml-1"></i>
            </div>
          </button>
          <div className="absolute bottom-8 left-8 right-8 text-center">
            <h3 className="text-white text-4xl font-serif mb-3">La Nostra Storia</h3>
            <p className="text-white/90 text-lg">Un viaggio nella qualità biologica italiana</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;